import React from 'react'
import PropTypes from 'prop-types'

class DhsvSocialItem extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    const { link } = this.props
    return (
      <div className={'blog-item social fb'}>
        <div className="inner">
          <div className="meta">
            <h3>Folge uns auf Facebook</h3>
            <div className="more">
              <a href={link}>Folgen</a>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

DhsvSocialItem.propTypes = {
  link: PropTypes.bool,
}

export default DhsvSocialItem
